module.exports = "/assets/data/789e7e436297c04f47d91425af53b21e-CB2.data.json";